import React, { useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import PublishIcon from "@material-ui/icons/Publish";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import axios from "axios";
//import ValidateRecord from "./ValidateRecord";
import ValidateNewReasonCode from "./ValidateReasonCodes";
//import ValidateDialog from "../../models/ValidateDialog";

import ValidateDialog from "./ValidateReasonCodes";

//import ValidateDialog from "../../../common/models/ValidateDialog";

// import ValidateDialog from "../models/ValidateDialog";
import { appUrl } from "../../../../../utils/config";
// import { appUrl } from "../../../../../utils/config";
const useStyles = makeStyles((theme) => ({
  header: {
    height: "15dvh",
    backgroundColor: "#f0f8ff",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  cancel: {
    position: "absolute",
    top: "10px",
    right: "10px",
    cursor: "pointer",
  },
  uploadBox: {
    width: "100%",
    marginTop: "2em",
    border: "1px solid black",
    backgroundColor: "#f5f5f5",
    padding: "2em 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  uploadText: {
    marginLeft: "auto",
  },
  uploadIcon: {
    fontSize: "40px",
    marginLeft: "auto",
    marginRight: "20px",
  },
  file: {
    marginTop: "2em",
    display: "flex",
    flexDirection: "column",
    gap: "1em",
    alignItems: "flex-start",
  },
  link: {
    color: "blue",
    textDecoration: "underline",
  },
  linkBox: {
    cursor: "pointer",
    display: "flex",
    gap: "0.5em",
  },
  bold: {
    fontWeight: 500,
  },
  criteria: {
    maxWidth: "500px",
  },
  uploadBtn: {
    backgroundColor: "#ec6535",
    color: "white",
    textTransform: "none",
    borderRadius: "50px",
    margin: "1em auto",
    padding: "5px 30px",
    "&:hover": {
      backgroundColor: "#ec6535",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const getSteps = () => ["Upload file", "Validation summary"];

export default function ReasonCodeUploader({ handleClose, setReasonCodesData  }) {
  const classes = useStyles();
  const [fileType, setFileType] = useState("xlsx");
  const [selectedFile, setSelectedFile] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [validation, setValidation] = useState(false);
  const [validationData, setValidationData] = useState([]);
  const steps = getSteps();

  const fileInputRef = useRef();

  const handleCancel = () => handleClose();
  const handleChange = (e) => setFileType(e.target.value);
  const handleUploadBoxClick = () => fileInputRef.current.click();
  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file) setSelectedFile(file);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) setSelectedFile(file);
  };
  const handleDragOver = (e) => e.preventDefault();

  const getAcceptAttribute = (type) => {
    switch (type) {
      case "xlsx":
        return ".xlsx, .xls";
      case "csv":
        return ".csv";
      //   case "json":
      //     return ".json";
      //   case "xml":
      //     return ".xml";
      default:
        return "";
    }
  };

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);
  const cancelFile = () => {
    setSelectedFile(null);
    setError(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleUpload = async () => {
    setLoading(true);
    setValidation(true);
    setError(null);

    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/uploadReasonCodes`;

    const formData = new FormData();
    formData.append("files", selectedFile);

    try {
      const res = await axios.post(url, formData);
      if (res.data.status) {
        setValidationData(res.data);
        // setReasonCodesData((prev) => !prev)
        handleNext();
      } else {
        setError(res.data.errorDescription || "Upload failed.");
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.errorDescription ||
        err?.response?.data?.errorMessage ||
        "An error occurred during upload.";
      setError(errMsg);
    } finally {
      setLoading(false);
      setValidation(false);
    }
  };

  const displayError = (
    <Container
      style={{
        width: "100%",
        border: "2px solid red",
        backgroundColor: "#ffeaea",
        padding: "0.8rem",
        marginBottom: "1.5em",
        textAlign: "center",
        fontSize: "0.875rem",
      }}
    >
      <Typography variant="body2">{error}</Typography>
    </Container>
  );

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Container>
            {error && displayError}
            <Box
              className={classes.uploadBox}
              onClick={handleUploadBoxClick}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              <Typography className={classes.uploadText}>
                Drag & drop file or click here to upload
              </Typography>
              <PublishIcon className={classes.uploadIcon} />
            </Box>
            <input
              type="file"
              hidden
              ref={fileInputRef}
              onChange={handleFileInputChange}
              accept={getAcceptAttribute(fileType)}
            />
            <Box className={classes.file}>
              <Typography>Select file type:</Typography>
              <FormControl variant="outlined" size="small">
                <Select value={fileType} onChange={handleChange}>
                  <MenuItem value="xlsx">.xlsx</MenuItem>
                  <MenuItem value="csv">.csv</MenuItem>
                  <MenuItem value="json">.json</MenuItem>
                  <MenuItem value="xml">.xml</MenuItem>
                </Select>
              </FormControl>

              {selectedFile && (
                <Box className={classes.linkBox}>
                  <Typography className={classes.link}>
                    {selectedFile.name}
                  </Typography>
                  <span onClick={cancelFile} style={{ cursor: "pointer" }}>
                    ❌
                  </span>
                </Box>
              )}
              <Box>
                <Typography className={classes.bold}>
                  Validation criteria
                </Typography>
                <Typography className={classes.criteria}>
                  Only excel files accepted (.csv, .xls, or .xlsx)
                </Typography>
                <Typography>First row must contain headers only</Typography>
                <Typography>
                  File should not contain blank rows or columns
                </Typography>
              </Box>
              <Button
                variant="contained"
                className={classes.uploadBtn}
                endIcon={<ChevronRightIcon />}
                onClick={handleUpload}
                disabled={!selectedFile}
              >
                Next
              </Button>
            </Box>
          </Container>
        );
      case 1:
        return (
          <ValidateNewReasonCode
            handleBack={handleBack}
            validationData={validationData}
            handleClose={handleClose}
            setReasonCodesData={setReasonCodesData}
            
          />
        );
      default:
        return <Typography>Unknown Step</Typography>;
    }
  };

  return (
    <Box>
      <Box className={classes.header}>
        <Box className={classes.cancel} onClick={handleCancel}>
          <Typography>Cancel ❌</Typography>
        </Box>
        <Typography variant="h4">Upload Reason Code File</Typography>
        <Typography style={{ marginTop: "1em" }}>
          Add/update Reason Code file
        </Typography>
      </Box>

      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {getStepContent(activeStep)}

      {loading && (
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <Dialog open={false} fullWidth>
        <ValidateDialog setReasonCodesData={setReasonCodesData} title="Validating file…" />
      </Dialog>
    </Box>
  );
}
